// extracted by mini-css-extract-plugin
export default {"box":"jRnjRDOyJVzZQIOiyhZy","textBox":"wxeW68i0QzEUDnd5SBqL"};